import { useQuery } from '@tanstack/react-query';
import { fetchAddOn } from '../services/smr-admin';
import { addonKeys } from './useAddOnsQuery';

export function useAddOnQuery(id: string | undefined) {
    return useQuery({
        queryKey: addonKeys.detail(id ?? ''),
        queryFn:  () => fetchAddOn(id!),
        enabled:  !!id,
    });
}
